import { axiosClient } from '@/libs/axios-client';
import {
  extractFileNameFromDisposition,
  saveBlobAsFile,
} from '@/utils/exportUtils';

const BASE = '/job-positions';

/** Company job position catalog: { count, items, canManage }. */
export const getJobPositions = async (company, status = 'active') => {
  const { data } = await axiosClient.get(BASE, { params: { company, status } });
  return data;
};

export const createJobPosition = async (payload) => {
  const { data } = await axiosClient.post(BASE, payload);
  return data;
};

export const updateJobPosition = async (id, payload) => {
  const { data } = await axiosClient.put(`${BASE}/${id}`, payload);
  return data;
};

export const archiveJobPosition = async (id) => {
  const { data } = await axiosClient.post(`${BASE}/${id}/archive`);
  return data;
};

export const restoreJobPosition = async (id) => {
  const { data } = await axiosClient.post(`${BASE}/${id}/restore`);
  return data;
};

/** Empty .xlsx with the columns the import reads, notes in `language`. */
export const downloadJobPositionTemplate = async (language) => {
  const response = await axiosClient.get(`${BASE}/template`, {
    params: { language },
    responseType: 'blob',
  });
  saveBlobAsFile(
    response.data,
    response.headers['content-type'] ||
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    extractFileNameFromDisposition(response.headers['content-disposition']) ||
      'sablon-radna-mesta.xlsx'
  );
};

/**
 * Excel import: `apply: false` returns the plan only, `apply: true` writes it.
 * With `rows` (the preview's rows, corrected) the file is not sent again.
 */
export const importJobPositions = async (company, file, apply = false, rows) => {
  const form = new FormData();
  form.append('company', company);
  form.append('apply', apply ? 'true' : 'false');
  // Rows corrected in the preview replace the file's.
  if (rows) form.append('rows', JSON.stringify(rows));
  else form.append('file', file);
  const { data } = await axiosClient.post(`${BASE}/import`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 5 * 60 * 1000,
  });
  return data;
};

/** Active employees with their position text and a suggested catalog position. */
export const getJobPositionMatching = async (company) => {
  const { data } = await axiosClient.get(`${BASE}/matching`, { params: { company } });
  return data;
};

/** assignments: [{ employeeId, jobPositionId }] */
export const assignJobPositions = async (company, assignments) => {
  const { data } = await axiosClient.post(`${BASE}/assign`, { company, assignments });
  return data;
};
